<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-title>Booker ID</v-card-title>
                <v-divider />
                <v-card-text>
                    <v-textarea auto-grow filled v-model="bookerMap" />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn text class="green--text" @click="updateBookerMap">Gem</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import jsonFormat from 'json-format'

export default {
    data () {
        return {
            bookerMap: null
        }
    },
    methods: {
        async getBookerMap () {
            const response = await this.$http().get('controlpanel/fh')
            this.bookerMap = jsonFormat(response.data)
        },
        async updateBookerMap () {
            await this.$http().put('controlpanel/fh', JSON.parse(this.bookerMap))
        }
    },
    created () {
        this.getBookerMap()
    }
}
</script>